export default __webpack_public_path__ + "sorting-icon-up.svg";